import { useCallback, useState } from "react";
import TextInput from "shared/@forms/TextInput";
import { useLogger } from "shared/@hooks/useLogger";
import { Auth } from "shared/@auth/Auth";
import Button from "shared/Button";
import Loader from "shared/Loader";
import styles from "./index.module.css";

export default function AmwayLookup() {
  const { logError } = useLogger({ prefix: "AmwayLookup" });
  const { makeAuthedRequest } = Auth.useContainer();

  const [iboNumber, setIBONumber] = useState("");

  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const lookup = useCallback(
    (iboNumber) => {
      setLoading(true);

      makeAuthedRequest(`/v1/membership/amway/${iboNumber}`)
        .then(async (res) => {
          if (res.ok) {
            return res.json();
          } else {
            const json = await res.json();
            throw new Error(json.message);
          }
        })
        .then((json) => {
          setResults(JSON.stringify(json, null, 2));
          setError(null);
        })
        .catch((err) => {
          setResults(null);
          setError(err.message);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [logError]
  );

  return (
    <div className={styles.container}>
      <form
        className={styles.search}
        onSubmit={(e) => {
          e.preventDefault();
          lookup(iboNumber);
        }}
      >
        <TextInput
          placeholder="IBO number"
          value={iboNumber}
          onChange={(e) => {
            setIBONumber(e.target.value);
          }}
        />
        <Button disabled={iboNumber === ""} className={styles.submitButton}>
          Look Up IBO
        </Button>
      </form>

      <div className={styles.results}>
        {loading ? (
          <Loader />
        ) : (
          <>
            {error && (
              <>
                <p>Received the following error from Amway service:</p>
                <pre className={styles.resultError}>
                  <code>{error}</code>
                </pre>
              </>
            )}

            {results && (
              <>
                <p>Received the following data from Amway service:</p>
                <pre className={styles.resultData}>
                  <code>{results}</code>
                </pre>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}
